export default "{\n    \"label_one\": \"{{name}}\",\n    \"label_0\": \"Établissement/Groupe\",\n    \"label_other\": \"{{count}} Établissement/Groupe\"\n}\n"